import { initGenericUIEvents, niTrackEvent } from '@xsite-ui/common.event-tracker';
import { initAdvertisingDisclosureScript } from '@xsite-ui/gaming.advertising-disclosure/client-script';
import { initVisitAgain } from '@xsite-ui/gaming.chart-desktop/visit-again-client-script';
import { initCookiePolicyScript } from '@xsite-ui/gaming.cookie-banner';
import { initFooterScripts } from '@xsite-ui/gaming.gaming-footer/client-script';
import { initMiniReviews } from '@xsite-ui/gaming.gaming-mini-review/client-script';
import { initLoadPopup } from '@xsite-ui/gaming.popup-loader/client-script';
import { initShowMoreScript } from '@xsite-ui/gaming.show-more/client-script';
import { timeOutPromise } from '@xsite-ui/gaming.theme';
import { hydrateComponents } from '@xsite-ui/partial-hydration/hydrate-components';

function userScrollUIEvent() {
  const pageLoadedTime = Date.now();

  window.addEventListener('scroll', userScrolled, { once: true });

  function userScrolled() {
    const userScrolledTime = Date.now();
    const timeBetweenPageLoadAndUserScroll = (userScrolledTime - pageLoadedTime) / 1000;

    niTrackEvent({
      category: 'Scroll down',
      action: 'scroll',
      optLabel: `${timeBetweenPageLoadAndUserScroll}s`,
      optValue: 0,
      optNonInteraction: false,
    });
  }
}

const componentsChunks = {
  Counter: () => import('@xsite-ui/gaming.counter/src/desktop/desktop-counter'),
  LiveFeed: () => timeOutPromise(() => import('@xsite-ui/common.live-feed/src/live-feed'), 3000),
};

(() => {
  initLoadPopup();
  initFooterScripts();
  userScrollUIEvent();
  initCookiePolicyScript();
  initVisitAgain();
  initShowMoreScript();
  initMiniReviews();
  initGenericUIEvents();
  initAdvertisingDisclosureScript();

  const stickyPodium = document.querySelector('#sticky-podium');

  if (stickyPodium) {
    import('@xsite-ui/gaming.sticky-podium/client-script').then((script) =>
      script.initStickyPodiumScript(),
    );
  }

  const legacyBrand = document.querySelector('[data-hook="legacy-brand-page-wrap"]');

  if (legacyBrand) {
    import('@xsite-ui/gaming.legacy-brand-popup-card/client-script').then(({ initLegacyBrands }) =>
      initLegacyBrands(),
    );
  }

  const fullTncPopup = document.querySelector('.tnc-with-popup');

  if (fullTncPopup) {
    import('@xsite-ui/gaming.product-tnc/client-script').then(({ initFullTncPopup }) =>
      initFullTncPopup(),
    );
  }

  hydrateComponents(componentsChunks, () => ({ default: window.theme }));
})();

export {};
